import React, { type SyntheticEvent } from 'react';
import { useTranslation } from '@/app/components/translations/Translation';
import { Cta } from '../Cta/styled';
import { FooterContainer } from './styled';
import { noop } from '../../../../Utilities';

type Props = {
  applyText?: string;
  handleApply: (e: SyntheticEvent) => void;
  isApplyDisabled?: boolean;
  clearText?: string;
  handleClear?: (e: SyntheticEvent) => void;
  isClearDisabled?: boolean;
} & React.HTMLAttributes<HTMLDivElement>;
const BasicModalFooter = ({
  applyText,
  handleApply,
  isApplyDisabled,
  clearText,
  handleClear,
  isClearDisabled,
  ...rest
}: Props) => {
  const { t } = useTranslation();

  return (
    <FooterContainer hasClear={!!handleClear} {...rest}>
      {handleClear && (
        <Cta
          isClear={true}
          onClick={isClearDisabled ? noop : handleClear}
          isDisabled={isClearDisabled}
          disabled={isClearDisabled}
        >
          {clearText || t('vacation.oss.filters.clear')}
        </Cta>
      )}
      {handleApply && (
        <Cta onClick={isApplyDisabled ? noop : handleApply} isDisabled={isApplyDisabled} disabled={isApplyDisabled}>
          {applyText || t('vacation.oss.filters.apply')}
        </Cta>
      )}
    </FooterContainer>
  );
};

export default BasicModalFooter;
